export default __webpack_public_path__ + "static/media/phone.bc2eb62b.svg";